export class AssociarQRCodeRequest {
    public qrcode: string;
    public colaboradorID: number;
    public gestorGuid: string;
    public valor: number;
    public cedenteGuid: string;
    public Senha: string;
    public SenhaConfirmacao: string;
}
